import type { z } from 'zod'
import type { apiZod } from '@/shared/api'

type TranscriptDto = z.infer<typeof apiZod.zTranscriptBody>
type SegmentDto = z.infer<typeof apiZod.zTranscriptSegment>

// start_ms/end_ms приходят int64 → в Zod-схеме bigint; ms-таймкоды влезают в
// number, приводим для форматирования.
function toSegment(dto: SegmentDto) {
  return {
    speaker: dto.speaker,
    speakerName: dto.speaker_name,
    speakerUsername: dto.speaker_username,
    startMs: Number(dto.start_ms),
    endMs: Number(dto.end_ms),
    text: dto.text,
    confidence: dto.confidence,
  }
}

export function toTranscript(dto: TranscriptDto) {
  return {
    meetingId: dto.meeting_id,
    recordingId: dto.recording_id,
    language: dto.language,
    createdAt: dto.created_at,
    anchor: dto.anchor,
    segments: (dto.segments ?? []).map(toSegment),
  }
}
